import TableCard from 'src/components/Table/TableCard';
import { useInfiniteWin32FileSetSection } from 'src/hooks/wdac';
import SectionTable from './SectionTable';

// Every section reports its total on each page, so the title carries it once the first page lands
// and reads as the bare label until then rather than flashing a zero.
const cardTitle = (section, firstPage) => {
  if (!firstPage) {
    return section.label;
  }

  const total = firstPage.count ?? firstPage.totalCount ?? 0;

  return `${section.label} (${total.toLocaleString()})`;
};

// Only the file list carries one, where the unsigned files are a subset of the rows rather than a
// count of their own.
const cardSubtitle = firstPage =>
  firstPage?.unsignedCount ? `${firstPage.unsignedCount.toLocaleString()} unsigned` : null;

// Binds a detail section to the file set endpoints. Anything that names a file set reads through
// here, whether it reached the set from the app version or from a customer application. It is a
// component rather than a call because each section needs its own hook.
const FileSetSectionTable = ({
  globalApplicationVersionId,
  fileSetId,
  section,
  enabled = true,
  maxHeight,
  minHeight,
  fill = false,
}) => {
  const query = useInfiniteWin32FileSetSection({
    globalApplicationVersionId,
    fileSetId,
    section: section.section,
    itemsKey: section.itemsKey,
    enabled,
  });

  const firstPage = query.data?.pages?.[0];

  return (
    <TableCard
      fill={fill}
      title={cardTitle(section, firstPage)}
      subtitle={cardSubtitle(firstPage)}
      minHeight={minHeight}
      maxHeight={maxHeight}>
      <SectionTable section={section} query={query} enabled={enabled} />
    </TableCard>
  );
};

export default FileSetSectionTable;
